import React from "react";
import { useNavigate } from "react-router-dom";
import { Heart, Plus } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function ProductCard({ product, index = 0, wide = false }) {
  const { money, addToCart, toggleWishlist, inWishlist } = useApp();
  const navigate = useNavigate();
  const imgs = product.images || [];
  const onSale = !!product.sale_price_usd;
  const soldOut = (product.inventory_qty ?? 1) <= 0;
  const needsOptions = (product.sizes && product.sizes.length) || (product.colors && product.colors.length) || (product.option_groups && product.option_groups.length);
  const wideCard = product.orientation === "landscape" || wide;
  const priceText = () => {
    if (product.pricing_mode === "range" && (product.price_min_usd || product.price_max_usd))
      return `${money(product.price_min_usd || product.price_usd)} – ${money(product.price_max_usd || product.price_usd)}`;
    if (product.pricing_mode === "from" || (product.option_groups && product.option_groups.length))
      return `From ${money(product.price_usd)}`;
    return onSale
      ? (<span><span className="line-through mr-2 opacity-60">{money(product.price_usd)}</span><span style={{ color: "var(--ev-accent)" }}>{money(product.sale_price_usd)}</span></span>)
      : money(product.price_usd);
  };

  return (
    <div data-testid={`product-card-${product.slug}`} className="group">
      <div className={`img-zoom relative ${wideCard ? "aspect-[3/2]" : "aspect-[3/4]"} bg-ev-bg cursor-pointer`}
        onClick={() => navigate(`/product/${product.slug}`)}>
        <img src={imgs[0]} alt={product.name} loading="lazy" className="w-full h-full object-cover" />
        {imgs[1] && <img src={imgs[1]} alt="" loading="lazy"
          className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700" />}
        {soldOut ? <span className="absolute top-3 left-3 bg-ev-text text-white text-[0.6rem] tracking-[0.15em] uppercase px-2.5 py-1">Sold Out</span>
          : onSale && <span className="absolute top-3 left-3 bg-white/90 text-[0.6rem] tracking-[0.15em] uppercase px-2.5 py-1">Sale</span>}
        <button data-testid={`wishlist-${product.slug}`}
          onClick={(e) => { e.stopPropagation(); toggleWishlist(product); }}
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/80 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-white">
          <Heart size={16} strokeWidth={1.4} fill={inWishlist(product.id) ? "var(--ev-accent)" : "none"} color={inWishlist(product.id) ? "var(--ev-accent)" : "currentColor"} />
        </button>
        {soldOut ? (
          <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm py-3.5 text-[0.62rem] tracking-[0.22em] uppercase font-medium text-center" style={{ color: "var(--ev-muted)" }}>Sold Out</div>
        ) : (
        <button data-testid={`quickadd-${product.slug}`}
          onClick={(e) => { e.stopPropagation(); needsOptions ? navigate(`/product/${product.slug}`) : addToCart(product); }}
          className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm py-3.5 text-[0.62rem] tracking-[0.22em] uppercase font-medium translate-y-full group-hover:translate-y-0 transition-transform duration-400 flex items-center justify-center gap-2">
          <Plus size={13} /> {needsOptions ? "Select Options" : "Quick Add"}
        </button>
        )}
      </div>
      <div className="pt-4 text-center">
        <button onClick={() => navigate(`/product/${product.slug}`)} className="font-serif text-lg leading-tight ev-link">{product.name}</button>
        <div className="mt-1.5 text-sm" style={{ color: "var(--ev-muted)" }}>{priceText()}</div>
      </div>
    </div>
  );
}
